import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Optional,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import _ from 'lodash';
import { HouseOrderDetailComponent } from '../../house-order-detail/house-order-detail.component';
import { MemberService } from '@root/router/index/member.service';
import { NoteV2Component } from '@root/router/component/note-v2/note-v2.component';
import { OrderV2Service } from '@root/router/order-v2/order-v2.service';
import { WritePermissionGurd } from '@root/util/decorator';
import { TranslateService } from '@root/shared/service/translate.service';
import { ViewVoucherComponent } from '@root/component/view-voucher/view-voucher.component';
import { MultiHouseCalendarService } from '../../calendar/multi-house-calendar/multi-house-calendar.service';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'host-house-order-finance',
  templateUrl: './house-order-finance.component.html',
  styleUrls: ['./house-order-finance.component.scss'],
})
export class HouseOrderFinanceComponent implements OnInit, OnChanges {
  @Input() code;
  @Input() list;
  @Input() currency;

  // @Input() orderDetail;
  @Input() pageType: 'sidebar' | 'modal' = 'sidebar';
  @Output() refreshModal = new EventEmitter();

  // datas = [
  //   {
  //     transaction_id: null,
  //     currency: "CNY",
  //     type: "",
  //     action_type: null,
  //     amount: null,
  //     action_time: "",
  //     payment_method: null,
  //     invoice: []
  //   }
  // ];
  refresh = false;
  in_options;
  out_options;
  in_pay_options;
  out_pay_options;
  constructor(
    private modalService: NzModalService,
    @Optional() private modalRef: NzModalRef,
    @Optional() private drawerRef: NzDrawerRef,
    public changeDetectorRef: ChangeDetectorRef,
    private multiHouseCalendarService: MultiHouseCalendarService,
    private orderService: OrderV2Service,
    private statusService: MemberService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.getOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes["orderDetail"] && changes["orderDetail"].currentValue) {
    //   this.format(changes["orderDetail"].currentValue);
    // }
  }

  getOptions() {
    this.orderService.gethouseStatusSettingOptions().subscribe((options) => {
      this.in_options = _.cloneDeep(_.get(options, 'income_item'));
      this.out_options = _.cloneDeep(_.get(options, 'outcome_item'));
      const transaction_item = _.get(options, 'transaction_item');
      _.forEach(transaction_item, (item) => {
        this.in_options.push(item);
        this.out_options.push(item);
      });
      this.in_pay_options = _.cloneDeep(_.get(options, 'income_method'));
      this.out_pay_options = _.cloneDeep(_.get(options, 'outcome_method'));
      const pay_method = _.get(options, 'pay_method');
      _.forEach(pay_method, (item) => {
        this.in_pay_options.push(item);
        this.out_pay_options.push(item);
      });
    });
  }

  // format(data) {
  //   this.clearDatas();
  //   this.datas = _.get(data, "income_and_expenses.list");
  // }

  @WritePermissionGurd('reservation_list')
  recordFinance() {
    if (this.statusService.isEditionExpiredOrExceed()) {
      this.statusService.editionExpiredOrExceedWarning();
      return;
    }
    const modalInstance = this.modalService.create({
      nzTitle: this.translateService.t('word.add_note'),
      nzContent: NoteV2Component,
      nzWidth: 900,
      nzFooter: null,
      nzComponentParams: {
        type: 'create',
        scope: 'order',
        orderCode: this.code,
        data: {
          currency_type: this.currency,
        },
        // currency: this.currency
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        // this.clearDatas();
      }
    });
  }

  // clearDatas() {
  //   this.datas = [
  //     {
  //       transaction_id: null,
  //       currency: "CNY",
  //       type: "",
  //       action_type: null,
  //       amount: null,
  //       action_time: "",
  //       payment_method: null,
  //       invoice: []
  //     }
  //   ];
  // }

  showCompleteTable() {
    const modalInstance = this.modalService.create({
      // nzTitle: this.translateService.syncGet('word.order_detail'),
      nzContent: HouseOrderDetailComponent,
      nzFooter: null,
      nzWidth: 900,
      nzComponentParams: {
        code: this.code,
        activatedIndex: 1,
        pageType: 'modal',
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      this.refresh = true;
      this.refreshModal.emit(this.refresh);
    });
  }

  getTypeName(type) {
    return type === 1 ? this.translateService.syncGet('word.income') : this.translateService.syncGet('word.outcome');
  }

  getInOptionName(method) {
    const item = _.find(this.in_options, { code: method });
    return item && item.item_name;
  }

  getOutOptionName(method) {
    const item = _.find(this.out_options, { code: method });
    return item && item.item_name;
  }

  getInTradeName(method) {
    const item = _.find(this.in_pay_options, { code: method });
    return item && item.method_name;
  }

  getOutTradeName(method) {
    const item = _.find(this.out_pay_options, { code: method });
    return item && item.method_name;
  }

  needRefresh(e) {
    if (e) {
      this.refresh = true;
      this.refreshModal.emit(this.refresh);
    }
  }

  viewVoucher(list) {
    if (list.length === 0) {
      return;
    }
    this.modalService.create({
      nzTitle: this.translateService.syncGet('word.account_voucher'),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }

  close() {
    if (this.modalRef) {
      this.modalRef?.close();
    } else {
      this.multiHouseCalendarService.cancelSelectReservation();
    }

    this.drawerRef?.close();
  }
}
